import { Outlet } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { buildLoginUrl } from "../lib/api";
import Sidebar from "./Sidebar";
import StatusBar from "./StatusBar";

export default function Layout() {
  const { me, loading } = useAuth();
  if (loading) {
    return <div className="p-10 text-sm text-[hsl(var(--muted-foreground))]">Loading...</div>;
  }

  if (!me?.authenticated) {
    return (
      <div className="min-h-screen p-10 bg-[hsl(var(--background))]">
        <section className="surface p-6 bg-black/75 max-w-3xl">
          <div className="label-eyebrow mb-2 text-[hsl(var(--currency-event))]">Admin dashboard</div>
          <h1 className="text-2xl font-semibold tracking-tight text-[#f3ead3]">Admin login required.</h1>
          <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))]">
            Your admin session is missing or expired. Sign in with the allowlisted Twitch account to continue.
          </p>
          <a
            href={buildLoginUrl("streamer", "/app")}
            target="_top"
            rel="noopener"
            className="mt-5 inline-flex items-center gap-2 px-5 py-3 rounded bg-[#9146ff] text-white font-medium hover:brightness-110 transition"
            data-testid="layout-admin-login-button"
          >
            <LogIn className="w-4 h-4" /> Login with Twitch as Admin
          </a>
        </section>
      </div>
    );
  }

  return (
    <div className="flex" data-testid="app-shell">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <StatusBar />
        <div className="p-6 max-w-[1600px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
